import styled from "styled-components";

export const Main = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(12px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 500px;
  background: var(--white-color);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border: 1px solid var(--gray-light);
  text-align: center;
  animation: slideUp 0.4s ease-out;

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  background: var(--primary-color-10);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 24px;

  svg {
    width: 40px;
    height: 40px;
    fill: var(--primary);
  }
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: var(--black-text);
  margin-bottom: 12px;
  font-family: var(--font-primary);
`;

export const Message = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: var(--black-text);
  margin-bottom: 0;
  font-family: var(--font-primary);
`;
